import { FC } from 'react';
import { Typography } from '@mui/material';

import { IOperator } from '../types';

import {
	StyledOperatorCard,
	StyledOperatorDescription,
	StyledOperatorImage,
	StyledOperatorImageGradientOverlay,
	StyledOperatorImageWrapper,
	StyledOperatorLogo,
	StyledOperatorTitleRow,
} from './OperatorCard.styled';

interface IOperatorCardProps {
	operator: IOperator;
	onClick: (operator: IOperator) => void;
}

export const OperatorCard: FC<IOperatorCardProps> = ({ operator, onClick }) => {
	return (
		<StyledOperatorCard
			onClick={() => onClick(operator)}
			data-testid={`operator-card-${operator.id}`}
		>
			<StyledOperatorImageWrapper>
				{operator.heroUrl && (
					<>
						<StyledOperatorImage src={operator.heroUrl} alt={operator.name} />
						<StyledOperatorImageGradientOverlay />
					</>
				)}
				<StyledOperatorTitleRow>
					{operator.iconUrl && (
						<StyledOperatorLogo src={operator.iconUrl} alt="" />
					)}
					<Typography
						variant="b1-sb"
						fontWeight={700}
						color="primary.main"
						sx={{
							flex: 1,
							minWidth: 0,
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap',
						}}
					>
						{operator.name}
					</Typography>
				</StyledOperatorTitleRow>
			</StyledOperatorImageWrapper>

			<StyledOperatorDescription>
				<Typography
					variant="l1"
					color="primary.main"
					sx={{
						wordBreak: 'break-word',
						overflowWrap: 'anywhere',
						hyphens: 'auto',
					}}
				>
					{operator.serviceAreaDescriptor}
				</Typography>
			</StyledOperatorDescription>
		</StyledOperatorCard>
	);
};
